/** Campaign column label — prefers API `displayCampaignName` (Meta sheet/webhook attribution). */
export function leadCampaignLabel(lead: {
  source?: string;
  campaignName?: string | null;
  displayCampaignName?: string | null;
  googleAdsUtmCampaign?: string | null;
}): string {
  const display = lead.displayCampaignName?.trim();
  if (display) return display;

  if (lead.source === 'WHATSAPP_INSTA_ADS') {
    return lead.campaignName?.trim() || '';
  }
  return lead.campaignName?.trim() || lead.googleAdsUtmCampaign?.trim() || '';
}
